// extracted by mini-css-extract-plugin
export default {"circleList":"CircleSwiper_circleList__fcuH9","leftList":"CircleSwiper_leftList__+85te","rightList":"CircleSwiper_rightList__GSphd"};